
export const reserveReleasedEnum = {
  RESERVE_RELEASED: 'RESERVE_RELEASED',
  STANDARD_LOADS: 'STANDARD_LOADS',
};

export const reserveReleasedRender = {
  RESERVE_RELEASED: 'Reserve Released',
  STANDARD_LOADS: 'Standard Loads',
};

export const reserveReleasedList = [
  {
    id: reserveReleasedEnum.RESERVE_RELEASED,
    name: reserveReleasedRender.RESERVE_RELEASED,
  },

  {
    id: reserveReleasedEnum.STANDARD_LOADS,
    name: reserveReleasedRender.STANDARD_LOADS,
  },
];

